import { GameType } from './const'

export const GamesRoute = '/games'

export const SolitaireClashRoute: Path = `${GamesRoute}/${GameType.SolitaireClash}`

export const BingoClashRoute: Path = `${GamesRoute}/${GameType.BingoClash}`

export const BingoTourRoute: Path = `${GamesRoute}/${GameType.BingoTour}`

export const EightBallStrikeRoute: Path = `${GamesRoute}/${GameType.EightBallStrike}`

export const SolitaireVentureRoute: Path = `${GamesRoute}/${GameType.SolitaireVenture}`

export const Pocket7GamesRoute: Path = `${GamesRoute}/${GameType.Pocket7Games}`

export const BlockolotRoute: Path = `${GamesRoute}/${GameType.Blockolot}`

export const BubbleBuzzRoute: Path = `${GamesRoute}/${GameType.BubbleBuzz}`

export const CashPoolRoute: Path = `${GamesRoute}/${GameType.CashPool}`

export const SolitaireInfiniteRoute: Path = `${GamesRoute}/${GameType.SolitaireInfinite}`

export const SolitaireSlamRoute: Path = `${GamesRoute}/${GameType.SolitaireSlam}`

export const BingoBlissRoute: Path = `${GamesRoute}/${GameType.BingoBliss}`

export const MatchNFlipRoute: Path = `${Pocket7GamesRoute}/${GameType.MatchNFlip}`

export const PlaySolitaireOnlineRoute: Path = `${Pocket7GamesRoute}/${GameType.PlaySolitaireOnline}`

export const TwentyOneGoldRoute: Path = `${Pocket7GamesRoute}/${GameType.TwentyOneGold}`

export const TileBlitzRoute: Path = `${Pocket7GamesRoute}/${GameType.TileBlitz}`

export const NumbersBlitzRoute: Path = `${Pocket7GamesRoute}/${GameType.NumbersBlitz}`

export const PoolClashRoute: Path = `${Pocket7GamesRoute}/${GameType.PoolClash}`

export const DunkShotRoute: Path = `${Pocket7GamesRoute}/${GameType.DunkShot}`

export const DominoesRoute: Path = `${Pocket7GamesRoute}/${GameType.Dominoes}`

export const GamesRoutes = {
  [GameType.SolitaireClash]: SolitaireClashRoute,
  [GameType.BingoClash]: BingoClashRoute,
  [GameType.BingoTour]: BingoTourRoute,
  [GameType.EightBallStrike]: EightBallStrikeRoute,
  [GameType.SolitaireVenture]: SolitaireVentureRoute,
  [GameType.Pocket7Games]: Pocket7GamesRoute,
  [GameType.Blockolot]: BlockolotRoute,
  [GameType.BubbleBuzz]: BubbleBuzzRoute,
  [GameType.CashPool]: CashPoolRoute,
  [GameType.SolitaireInfinite]: SolitaireInfiniteRoute,
  [GameType.SolitaireSlam]: SolitaireSlamRoute,
  [GameType.BingoBliss]: BingoBlissRoute,
  [GameType.MatchNFlip]: MatchNFlipRoute,
  [GameType.PlaySolitaireOnline]: PlaySolitaireOnlineRoute,
  [GameType.TwentyOneGold]: TwentyOneGoldRoute,
  [GameType.TileBlitz]: TileBlitzRoute,
  [GameType.NumbersBlitz]: NumbersBlitzRoute,
  [GameType.PoolClash]: PoolClashRoute,
  [GameType.DunkShot]: DunkShotRoute,
  [GameType.Dominoes]: DominoesRoute,
}
